import { Action } from "@ngrx/store";
import { CHANGE_TO_CNP_CHANNEL, CHANGE_TO_CP_CHANNEL, CHANGE_TO_WHATSAPP_CHANNEL } from "./channel.actions";

export function channelReducer( state: string = "CNP", action: Action ){
  switch( action.type ){
    case CHANGE_TO_CNP_CHANNEL:
      return "CNP";
    case CHANGE_TO_CP_CHANNEL:
      return "CP";
    case CHANGE_TO_WHATSAPP_CHANNEL:
      return "WHATSAPP";
    default:
      return state
  }
}
